import { render, staticRenderFns } from "./DevolveModification.vue?vue&type=template&id=36b2a6e9&scoped=true&"
import script from "./DevolveModification.vue?vue&type=script&lang=ts&"
export * from "./DevolveModification.vue?vue&type=script&lang=ts&"
import style0 from "./DevolveModification.vue?vue&type=style&index=0&id=36b2a6e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2a6e9",
  null
  
)

export default component.exports